var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-expand",
    attrs: {
      "aria-expanded": _vm.userExpanded
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.matchesMediaQuery),
      expression: "matchesMediaQuery"
    }],
    staticClass: "cm-expand__header",
    on: {
      "click": _vm.toggleExpansion
    }
  }, [_c('h2', {
    staticClass: "cm-expand__header__heading"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('button', {
    staticClass: "cm-expand__header__arrow",
    attrs: {
      "type": "cm-button",
      "tabindex": "0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.userExpanded ? "navigateup" : "navigatedown") + "\n    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpanded),
      expression: "isExpanded"
    }],
    staticClass: "cm-expand__expandable-region"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-affc819c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/expand.vue
// module id = null
// module chunks = 